const layout2Settings = {
  header: { show: true },
  searchBox: { open: false },
  secondarySidebar: { show: false },
  leftSidebar: {
    open: true,
    secondaryNavOpen: false,
    theme: "sidebar-custom-orange"
  }
};

export default layout2Settings;
